export const CHECKOUT_URL = 'https://reflexpractice-en.impultienda.ar/checkout/';

export const IMAGES = {
  mainMockup: 'https://cdn.magicpatterns.com/uploads/hd8EWCJSBhxpd9PdnvL9Fc/REFLEXPRACTICE-EN.png',
  elly: 'https://cdn.magicpatterns.com/uploads/fDZjWjkHybMxTWd2xeaw4Y/ELLY_DELGADO_-_REFLEXOLOGY.png',
};
